import { render, staticRenderFns } from "./ventas_por_mesas.vue?vue&type=template&id=53716a04&"
import script from "./ventas_por_mesas.vue?vue&type=script&lang=js&"
export * from "./ventas_por_mesas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports